// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// import AuthService from "../services.js/auth.service";
// import { useSelector } from "react-redux";

// export const login = createAsyncThunk(
//   "auth/login",
//   async ({ email, password }, thunkAPI) => {
//     try {
//       const data = await AuthService.login(email, password);
//       if (data === undefined) {
//         throw "e";
//       } else {
//         return { user: data };
//       }
//     } catch (error) {
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );

// export const logout = createAsyncThunk("auth/logout", async () => {
//   await AuthService.logout();
// });

// const initialState = {
//   isLoggedIn: false,
//   user: null,
// };
// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   extraReducers: {
//     [login.fulfilled]: (state, action) => {
//       state.isLoggedIn = true;
//       state.user = action.payload.user;
//     },
//     [login.rejected]: (state, action) => {
//       state.isLoggedIn = false;
//       state.user = null;
//     },
//     [logout.fulfilled]: (state, action) => {
//       state.isLoggedIn = false;
//       state.user = null;
//     },
//   },
// });

// export const selectUser = (state) => state.auth;

// export const authReducer = authSlice.reducer;


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AuthService from "../services.js/auth.service";

export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, thunkAPI) => {
    try {
      const data = await AuthService.login(email, password);
      if (data === undefined) {
        throw "e";
      } else {
        return { user: data };
      }
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  await AuthService.logout();
});

const initialState = {
  isLoggedIn: false,
  user: null,
};

// the login payload is [token, role, user]; never keep the password hash
const withoutSecrets = (user) => {
  if (!user || typeof user !== "object") return user;
  const { password, hashedJwt, ...rest } = user;
  return rest;
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // fresh data of the logged-in user (roles changed from Users) — applies
    // new permissions without signing in again
    userRefreshed: (state, action) => {
      if (!state.isLoggedIn || !Array.isArray(state.user) || !action.payload) {
        return;
      }
      const user = withoutSecrets(action.payload);
      if (user.role) state.user[1] = user.role;
      state.user[2] = { ...withoutSecrets(state.user[2]), ...user };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.isLoggedIn = true;
        const payload = action.payload.user;
        state.user = Array.isArray(payload)
          ? payload.map((item, i) => (i === 2 ? withoutSecrets(item) : item))
          : payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoggedIn = false;
        state.user = null;
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.isLoggedIn = false;
        state.user = null;
      });
  },
});

export const { userRefreshed } = authSlice.actions;

export const selectUser = (state) => state.auth;

export const authReducer = authSlice.reducer;
